/**
 * LeadsTable — Iter 156.10. Extracted from `LeadsPage.jsx`.
 * Table + pagination. Stateless apart from row-click navigation.
 */
import { Phone, ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CallCustomerButton from "../../components/CallCustomerButton";

export default function LeadsTable({
  loading, leads, hasFilters, STATUS_LABELS,
  page, pages, setPage,
}) {
  const navigate = useNavigate();
  return (
    <>
      <div className="bento-card overflow-hidden p-0">
        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="spinner" />
          </div>
        ) : leads.length === 0 ? (
          <div className="empty-state py-16">
            <p className="text-lg">No leads found</p>
            <p className="text-sm mt-1">
              {hasFilters ? "Try adjusting your filters" : "Leads from WATI will appear here automatically"}
            </p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Lead</th><th>Status</th><th>Category</th><th>Source</th><th>Created</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr
                  key={lead.id}
                  onClick={() => navigate(`/leads/${lead.id}`)}
                  className="cursor-pointer"
                  data-testid={`lead-row-${lead.id}`}
                >
                  <td>
                    <div className="flex items-center gap-3">
                      <div className="avatar">{lead.name?.charAt(0)?.toUpperCase() || "?"}</div>
                      <div>
                        <div className="flex items-center gap-2">
                          {lead.source === "wati" && <span className="whatsapp-indicator" />}
                          <p className="font-medium text-[#1C1917]">{lead.name}</p>
                        </div>
                        <p className="text-sm text-[#57534E] flex items-center gap-1">
                          <Phone size={12} /> {lead.phone}
                          <span onClick={(e) => e.stopPropagation()} className="ml-1">
                            <CallCustomerButton phone={lead.phone} customerName={lead.name} leadId={lead.id} label="" />
                          </span>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className={`status-${lead.status} px-2 py-0.5 text-xs uppercase tracking-wider rounded-sm`}>
                      {STATUS_LABELS[lead.status] || lead.status}
                    </span>
                  </td>
                  <td>
                    {lead.category ? (
                      <span className={`category-badge category-${lead.category.toLowerCase().replace(/ /g, "-")}`}>{lead.category}</span>
                    ) : (
                      <span className="text-[#A8A29E]">-</span>
                    )}
                  </td>
                  <td>
                    <span className="text-sm text-[#57534E] capitalize">
                      {lead.source === "wati" ? "WhatsApp" : lead.source}
                    </span>
                  </td>
                  <td>
                    <span className="text-sm text-[#57534E]">
                      {new Date(lead.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {pages > 1 && (
        <div className="flex items-center justify-between mt-4">
          <p className="text-sm text-[#57534E]">Page {page} of {pages}</p>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
              className="btn-secondary p-2 disabled:opacity-50"
              data-testid="prev-page-btn"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              onClick={() => setPage((p) => Math.min(pages, p + 1))}
              disabled={page === pages}
              className="btn-secondary p-2 disabled:opacity-50"
              data-testid="next-page-btn"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
